import { Button } from "@components/atoms/Button"
import { ResponsiveImage } from "@components/atoms/ResponsiveImage"
import { cn } from "@utils/tw"
import { defineBlock, EditableText, InnerBlocks, usePostTitleEditor } from "eddev/blocks"
import { Link } from "eddev/routing"

export const meta: BlockMeta = {
  title: "Leadership Header",
  icon: "block-default",
  postMetaBlock: {
    fieldName: "leadershipHeader",
    postTypes: ["leadership"],
  },
  conditions: {
    postTypes: ["leadership"],
  },
}

export default defineBlock("leadership/leadership-header", (props) => {
  return (
    <div className={cn("w-full content-sized mt-5 mb-blockSpace flex flex-col gap-8 md:gap-10")}>
      <Button variant="medium" size="sm" href="/leadership">
        Back to Leadership
      </Button>
      <div className="w-full grid grid-cols-1 md:grid-cols-12 gap-7 md:gap-0">
        <div className="order-2 md:order-1 md:col-span-6 flex flex-col gap-7 md:gap-6">
          <div className="flex flex-col gap-3 md:gap-2">
            <h1 className="type-sans-3-xl-semibold">
              {env.admin ? (
                <EditableText as="span" store={usePostTitleEditor()} className="" placeholder="Enter a title" />
              ) : (
                props.leadership?.title
              )}
            </h1>
            <h2 className="type-mono-base-regular">
              {props.jobTitle || (env.admin ? "(Enter job title in side panel)" : "")}
            </h2>
          </div>
          <EditableText
            store="headline"
            as="p"
            className="type-serif-lg-regular md:type-serif-xl-regular"
            placeholder="Enter a headline"
          />
          <div className="w-full">
            <InnerBlocks allowedBlocks={["#inline"]} defaultBlocks={[["core/paragraph", {}]]} orientation="vertical" />
          </div>
        </div>
        <div className="hidden order-2 md:block md:col-span-1" />
        <div className="order-1 md:order-3 md:col-span-5 rounded-md overflow-hidden aspect-[429/480]">
          {props.featuredImage?.mediaItemUrl ? (
            <ResponsiveImage {...props.featuredImage} className="w-full h-full" objectFit="cover" />
          ) : (
            env.admin && (
              <div className="w-full aspect-square p-5 bg-slate300 flex items-center justify-center text-slate950 type-sans-base-regular">
                Featured image not set. Please set a featured image to display here.
              </div>
            )
          )}
        </div>
      </div>
    </div>
  )
})
